import React from 'react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';
import { CardFooter } from '@/components/ui/card';
interface CompanyAccessInfoProps {
  isAdmin: boolean;
  noResults: boolean;
  isLoading: boolean;
}
const CompanyAccessInfo: React.FC<CompanyAccessInfoProps> = ({
  isAdmin,
  noResults,
  isLoading
}) => {
  // Only show the admin alert when needed
  if (!isAdmin) {
    return <Alert className="mb-6 hidden">
        <Info className="h-4 w-4" />
        <AlertTitle>Access Restricted</AlertTitle>
        <AlertDescription>
          As a regular user, you can only see companies you are a member of. Contact an administrator if you need access to additional companies.
        </AlertDescription>
      </Alert>;
  }

  // Show the no results message in the footer when appropriate
  if (noResults && !isLoading) {
    return <CardFooter className="justify-end">
        <p className="text-muted-foreground">
          {isAdmin ? "No companies found." : "You don't have access to any companies. Please contact an administrator."}
        </p>
      </CardFooter>;
  }
  return null;
};
export default CompanyAccessInfo;